import React from 'react';
import {
    getImplantPrice,
    getBridgePrice,
    getCurrencySign
} from '../../services/cart';

import {
    isoToUniversal,
    getBridgedTeeth,
    getToothIndex,
    getToothPosition
} from '../common/teeth';

function OrderReview(props) {

    const {
        teethState,
        currency,
        bridges
    } = props;


    const tableHeads = [abraStr.type,abraStr.material,abraStr.teeth,abraStr.implants,abraStr.price];
    return (
        <div id='order-review'>
            <table>
                <tr>
                    {tableHeads.map(head=>
                        <th key={head}>{head}</th>)
                    }
                </tr>

                    {
                        teethState
                            .filter(tooth=>tooth.state === "implant" && tooth.isTelescopicCrown)
                            .map(tooth=>
                                <tr key={tooth.id}>
                                    <td>
                                        <div className={`abra-cart-type ${tooth.state}`}/>
                                        <p>{abraStr.telescopicCrown}</p>
                                    </td>
                                    <td>
                                        {tooth.material}
                                    </td>
                                    <td>
                                        1
                                        <span>{tooth.id}</span>
                                    </td>
                                    <td>
                                        1
                                        <span>{tooth.id}</span>
                                    </td>
                                    <td>
                                        {`${getCurrencySign(currency)}${getImplantPrice(tooth,currency)}`}
                                    </td>
                                </tr>
                            )
                    }
                {
                    bridges.map((bridge,index)=>{

                        let bridgeTeethLength = 0;
                        let bridgeImplants = [];
                        let bridgeRanges = [];
                        bridge.teeth.map(range=>{
                                const bridgeTeeth  = getBridgedTeeth(range,true);
                                bridgeTeethLength += bridgeTeeth.length;
                                const teethWithIndices = {};
                                const position = getToothPosition(range);
                                const teethIndices = bridgeTeeth.map(tooth=> {
                                    const index = getToothIndex(position, tooth);
                                    teethWithIndices[index] =  tooth;
                                    return index;
                                });
                                const [firstTeethInBridge, lastTeethInBridge] = [ Math.min(...teethIndices),Math.max(...teethIndices)]
                                const implants = bridgeTeeth.filter(bridgeTooth=>
                                    teethState.find(tooth=>
                                        tooth.id === bridgeTooth
                                    ).state === "implant"
                                );
                                bridgeImplants = [...bridgeImplants,...implants];
                                bridgeRanges = [...bridgeRanges,[teethWithIndices[firstTeethInBridge], teethWithIndices[lastTeethInBridge]] ];
                        });
                        const teethRangesString =  bridgeRanges.map((range,index)=>
                            `${index? " ;":""}${range[0]}-${range[1]}`
                        )

                        return(
                            <tr key={`bridge-${index}`}>
                                <td>
                                    <div className={`abra-cart-type ${bridge.bridgeType}-bridge`}/>
                                    <p>{bridge.bridgeType === "telescopic"? abraStr.telescopicBridge : abraStr.telescopicOverdenture}</p>
                                </td>
                                <td>
                                    {bridge.material}
                                </td>
                                <td>
                                    {bridgeTeethLength}
                                    <span>{teethRangesString}</span>
                                </td>
                                <td>
                                    {bridgeImplants.length}
                                    {bridgeImplants && <span>{bridgeImplants.map((tooth,index)=>
                                        `${tooth}${index < bridgeImplants.length -1? "; " : ""}`)}
                                    </span>}
                                </td>
                                <td>
                                    {`${getCurrencySign(currency)}${getBridgePrice(teethState,currency,bridge)}`}
                                </td>
                            </tr>
                        );
                    })
                }
            </table>
        </div>
    );
}

export default OrderReview;